import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqExportCasesQuery } from './types'

export const exportCasesMutation: ({
  isEoir,
}: {
  isEoir?: boolean
}) => MutationOptions<Response, Error, ReqExportCasesQuery> = ({ isEoir = false }) => ({
  mutationFn: (payload) => {
    return w.post(payload, API_ENDPOINTS.business.v1.case.export.index).res()
  },
  onSuccess: async (res) => {
    const blob = await res.blob()
    const fileName = isEoir ? 'eoir-cases.csv' : 'immigration-cases.csv'
    downloadBlob(blob, fileName)
  },
})

function downloadBlob(blob: Blob, fileName = 'download.csv') {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
